<template>
  <yd-layout class="maipiao">
    <yd-preview :buttons="[]" class="meeting_inf">
      <yd-preview-header class="meeting_inf_header" style="background: none!important;">
        <div slot="right" class="fair-name fair">{{ fairDetail.fair_name }} {{ tuiguangren }}</div>
      </yd-preview-header>
      <yd-preview-item>
        <div slot="left" class="meeting_notify">报名时间：</div>
        <div slot="right" class="meeting_notify">{{ fairDetail.reserve_time }}至{{ fairDetail.end_reserve_time }}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left" class="meeting_notify">会议时间：</div>
        <div slot="right" class="meeting_notify">{{ fairDetail.start_time }}至{{ fairDetail.end_time }}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left" class="meeting_notify">会议地址：</div>
        <div slot="right" class="meeting_notify">{{ fairDetail.address }}</div>
      </yd-preview-item>
      <!-- <hr> -->
    </yd-preview>
    <yd-preview v-for="(item,index) in ticketList" :key="index" :buttons="[]">
      <yd-preview-header class="meeting_inf_header" style="background: none!important;">
        <div slot="left" class="fair-name fair">{{ item.name }}</div>
      </yd-preview-header>
      <div v-for="(ticket,key) in item.goods_attr" :key="key" v-if="ticket.goods_ext.length > 0">
        <yd-preview-item>
          <div slot="left" class="ticket-name"><img src="../../assets/image/putongmenpiao.png" alt="">{{ ticket.name }}
          </div>
          <div slot="right" class="ticket-price"><span
            v-if="ticket.goods_ext.length > 0">{{ ticket.goods_ext[0].goods_price }}</span>元/人
          </div>
        </yd-preview-item>
        <div v-if="ticket.goods_ext.length > 0">
          <yd-preview-item v-if="ticket.goods_ext.length > 0" style="padding-bottom: .2rem;">
            <div slot="left">
              <yd-button type="warning" @click.native="buyTicket(item.id,ticket)" class="add">+ 添加参会者</yd-button>
            </div>
            <div slot="right"></div>
          </yd-preview-item>
          <div v-for="(product,key) in productlist" :key="key" class="canhuiren">
            <div v-if="product.id === ticket.goods_ext[0].id" v-for="(contacts,index) in product.contacts"
                 :key="index" style="color: #333" class="canhuiren_v_for">
              <div class="member_info">
                <div class="member_name"><img src="../../assets/image/touxiang.png" alt="">{{ contacts.user_name }}
                </div>
                <div style="float: left;width: 40%;">{{ contacts.mobile_phone }}</div>
                <div style="float: left;width: 25%;">
                  {{ contacts.ExhContactsExt ? contacts.ExhContactsExt.zhiwu : '' }}
                </div>
              </div>
              <div class="operation">
                <yd-icon name="delete" @click.native="delContact(ticket.goods_ext[0], index)"></yd-icon>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
    </yd-preview>
    <yd-cell-group class="waibu_cell_box lxr">
      <yd-preview-header class="meeting_inf_header" style="background: none!important;">
        <div slot="left" class="fair-name">联系人信息</div>
        <div slot="right"></div>
      </yd-preview-header>
      <yd-cell-item class="lxr">
        <span slot="left">联系人：</span>
        <yd-input slot="right" required v-model="order.contact" max="20" placeholder="请输入联系人" class="no-af"></yd-input>
      </yd-cell-item>
      <yd-cell-item class="sjh">
        <span slot="left">手机号：</span>
        <yd-input slot="right" required v-model="order.mobile_phone" regex="mobile" placeholder="请输入手机号码"
                  class="no-af"></yd-input>
      </yd-cell-item>
      <yd-cell-item v-if="!isLogin && codeOpen">
        <yd-icon slot="icon" name="verifycode" size=".45rem"></yd-icon>
        <input type="text" slot="right" v-model="code" placeholder="请输入验证码">
        <yd-sendcode slot="right"
                     v-model="codeStatus"
                     storage-key="hahaha"
                     @click.native="sendCode"
                     type="warning"
        ></yd-sendcode>
      </yd-cell-item>
    </yd-cell-group>
    <yd-cell-group class="waibu_cell_box">
      <yd-cell-item @click.native="invoiceShow = true" v-if="system.is_open !== '0'">
        <span slot="left">发票：</span>
        <span slot="right">{{ invoiceMsg }}<yd-icon name="more"></yd-icon></span>
      </yd-cell-item>
    </yd-cell-group>
    <yd-cell-group class="waibu_cell_box m-cell-box">
      <yd-cell-item arrow type="label" v-show="couponList.length > 0">
        <span slot="left">优惠券：</span>
        <select slot="right" v-model="coupon">
          <option value="">选择优惠券</option>
          <option v-for="(c,index) of couponList" :key="index" :value="c.id">{{ c.coupon_name }}</option>
        </select>
      </yd-cell-item>
      <yd-cell-item>
        <span slot="left">留言：</span>
        <yd-input slot="right" v-model="order.message" :show-success-icon="false" :show-error-icon="false"
                  placeholder="特殊需求请留言"></yd-input>
      </yd-cell-item>
    </yd-cell-group>
    <yd-popup v-model="invoiceShow" class="invoice" position="bottom" height="80%" style="color: black;">
      <div class="close_btn">
        <span @click="invoiceShow = false">
          <img src="~assets/image/white_close.png" alt="">
        </span>
      </div>
      <yd-flexbox>
        <yd-flexbox-item class="invoice_h1">发票</yd-flexbox-item>
      </yd-flexbox>
      <div v-if="system.is_open === '1'">
        <h3>开发票</h3>
        <yd-switch v-model="iskai" style="margin-bottom: .3rem;"></yd-switch>
      </div>
      <div v-show="iskai">
        <p style="color: #666;margin: .2rem 0;">{{ system.info }}</p>
        <h3>收款方</h3>
        <yd-radio-group v-model="order.shoukuanf" class="radio_box">
          <yd-radio v-for="(i,key) in system.shoukuanfang" :val="key" :key="key">{{ key }}</yd-radio>
        </yd-radio-group>
        <h3>发票类型</h3>
        <yd-radio-group v-model="invoice.type" class="radio_box">
          <yd-radio v-for="(i,key) in system.invoicetype" :val="key" :key="key" v-show="invoice_type[key]">{{ i }}</yd-radio>
        </yd-radio-group>
        <h3 v-show="!wuxu">发票抬头</h3>
        <yd-radio-group v-model="invoice.leixing" class="radio_box" v-show="!wuxu">
          <yd-radio v-if="(system.InvoiceLeixing === '3' || system.InvoiceLeixing === '1')" val="1">个人</yd-radio>
          <yd-radio v-if="(system.InvoiceLeixing === '3' || system.InvoiceLeixing === '2')" val="2">单位</yd-radio>
        </yd-radio-group>
        <div class="invoice_inf" v-show="!wuxu">
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceNameRequire">*</i> 单位名称：</span>
            <input slot="right" type="text" v-model="invoice.name" class="input_height" placeholder="请输入单位名称">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceShuinoRequire">*</i> 纳税人识别码：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.shuino" placeholder="请输入纳税人识别码">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceZzaddressRequire">*</i> 单位地址：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.zzaddress" placeholder="请输入单位地址">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceZzphoneRequire">*</i> 电话号码：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.zzphone" placeholder="请输入电话号码">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceZzbankRequire">*</i> 开户银行：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.zzbank" placeholder="请输入开户银行">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceZzaccountRequire">*</i> 银行账户：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.zzaccount" placeholder="请输入银行账户">
          </yd-cell-item>
          <yd-radio-group v-model="invoice.content" class="radio_box" v-show="!wuxu">
            <h3>开票内容</h3>
            <yd-radio v-for="(i,key) in system.invoice_content" :key="key" :val="key">{{ i }}</yd-radio>
          </yd-radio-group>
          <yd-radio-group v-show="(system.separate === '1') && !wuxu" v-model="invoice.way" class="radio_box">
            <h3>分开开票</h3>
            <yd-radio val="1">开一张发票</yd-radio>
            <yd-radio val="2">分开开票</yd-radio>
          </yd-radio-group>
          <div v-if="system.invoicemail === '1'">
            <h3 slot="left">邮递</h3>
            <yd-switch v-model="invoice.needmail"></yd-switch>
          </div>
          <div
            v-show="invoiceLxrRequire || invoiceMobileRequire || invoiceEmailRequire || invoicePcdRequire || invoiceAddressRequire">
            <h3 style="margin-bottom: .14rem;">收票人信息</h3>
            <yd-cell-item v-show="invoiceLxrRequire">
              <span slot="left"><i style="color: red" v-show="invoiceLxrRequire">*</i> 收票人姓名：</span>
              <input slot="right" type="text" class="input_height" v-model="invoice.lxr" placeholder="请输入收票人姓名">
            </yd-cell-item>
            <yd-cell-item v-show="invoiceMobileRequire">
              <span slot="left"><i style="color: red" v-show="invoiceMobileRequire">*</i> 收票人手机：</span>
              <input slot="right" type="text" class="input_height" v-model="invoice.mobile" placeholder="请输入收票人手机">
            </yd-cell-item>
            <yd-cell-item v-show="invoiceEmailRequire">
              <span slot="left"><i style="color: red" v-show="invoiceEmailRequire">*</i> 收票人邮箱：</span>
              <input slot="right" type="text" class="input_height" v-model="invoice.email" placeholder="请输入收票人邮箱">
            </yd-cell-item>
            <yd-cell-item arrow v-show="invoicePcdRequire">
              <span slot="left"><i style="color: red" v-show="invoicePcdRequire">*</i> 所在地区：</span>
              <input slot="right" type="text" @click.stop="cityShow = true" class="input_height" v-model="pcd" readonly
                     placeholder="请选择省市县">
            </yd-cell-item>
            <yd-cityselect v-model="cityShow"
                           :callback="result1"
                           :provance="this.invoice.province"
                           :city="this.invoice.city"
                           :area="this.invoice.dist"
                           :items="district"
            ></yd-cityselect>
            <yd-cell-item v-show="invoiceAddressRequire">
              <span slot="left"><i style="color: red" v-show="invoiceAddressRequire">*</i> 详细地址：</span>
              <input slot="right" type="text" v-model="invoice.address" class="input_height" placeholder="请输入详细地址">
            </yd-cell-item>
          </div>
          <yd-button size="large" type="primary" @click.native="saveInvoice">确定</yd-button>
        </div>
      </div>
    </yd-popup>
    <yd-popup v-model="contactsShow" position="bottom" height="80%" class="add_popup">
      <yd-flexbox>
        <div class="close_btn cover-item iconfont cover-item-line icon-shoucang1">
          <span @click="contactsShow = false">
            <img src="~assets/image/white_close.png" alt="">
          </span>
        </div>
      </yd-flexbox>
      <cell-components class="bk_none"
                       :fieldsData="fieldsData"
                       :fields="fields"
                       @refreshData="refreshData"
      ></cell-components>
      <yd-button size="large" type="primary" @click.native="saveContacts" v-preventReClick style="margin-left: .1rem;">
        保存
      </yd-button>
    </yd-popup>
    <div class="submit_total_price">
      <yd-cell-group class="waibu_cell_box" style="margin-bottom: 0;line-height: 1rem;width: 100%;">
        <yd-flexbox>
          <yd-flexbox-item>总价：<span class="order_amount">{{ amount }}</span> 元</yd-flexbox-item>
          <yd-flexbox-item>人数：<span class="order_amount">{{ number }}</span> 人</yd-flexbox-item>
          <yd-flexbox-item v-show="couponAmount !== 0">
            <div>优惠：<span class="order_amount">{{ couponAmount }}</span> 元</div>
          </yd-flexbox-item>
          <yd-flexbox-item>应付：<span
            class="order_amount">{{ couponAmount ? (amount - couponAmount).toFixed(2) : amount }}</span>
            元
          </yd-flexbox-item>
        </yd-flexbox>
      </yd-cell-group>
      <div class="submit">
        <yd-button size="large" type="primary" @click.native="submitOrder" class="btn_submit" v-preventReClick>提交订单
        </yd-button>
      </div>
    </div>
  </yd-layout>
</template>

<script type="text/babel">
import axios from 'axios'
import CellComponents from './compontents/cell'
import {CitySelect} from 'vue-ydui/dist/lib.rem/cityselect'
import District from 'ydui-district/dist/gov_province_city_area_id'
import Vue from 'vue'

Vue.component(CitySelect.name, CitySelect)

export default {
  props: ['xuzhi'],
  components: {CellComponents},
  data() {
    return {
      cityShow: false,
      pcd: '',
      district: District,
      isLogin: this.$store.state.isLogin,
      token: this.$store.state.token,
      checkbox2: [],
      fairDetail: [],
      ticketList: [],
      invoice_type: [],
      invoiceMsg: '是否开票',
      invoiceShow: false,
      wuxu: false,
      invoiceNameRequire: true,
      invoiceShuinoRequire: true,
      invoiceZzaddressRequire: false,
      invoiceZzphoneRequire: false,
      invoiceZzbankRequire: false,
      invoiceZzaccountRequire: false,
      invoiceAddressRequire: false,
      invoicePcdRequire: false,
      invoiceEmailRequire: false,
      invoiceMobileRequire: false,
      invoiceLxrRequire: false,
      contactsShow: false,
      codeStatus: false,
      code: '',
      codeOpen: false,
      field: [],
      fieldsData: {},
      system: {},
      fieldList: [],
      order: {
        contact: localStorage.getItem('name'),
        mobile_phone: localStorage.getItem('mobile_phone'),
        shoukuanf: ''
      },
      amount: 0,
      number: 0,
      invoice: {
        type: '',
        content: '',
        way: 1,
        leixing: '',
        lxr: '',
        mobile: '',
        province: '',
        city: '',
        dist: '',
        address: '',
        name: '',
        shuino: '',
        zzaccount: '',
        zzbank: '',
        zzphone: '',
        zzaddress: '',
        email: '',
        needmail: 0
      },
      iskai: 0,
      hallid: '',
      fields: [],
      goodsExt: [],
      productlist: {},
      params: this.$route.params,
      ExhContactsExt: {},
      tuiguangren: '',
      couponAmount: 0,
      couponList: [],
      coupon: ''
    }
  },
  methods: {
    getFairDetail() {
      let data = {id: this.params.id}
      axios
        .post('/fair/fair-detail', data)
        .then(this.getFairDetailSucc)
      let data1 = {fairid: this.params.id, type_: 'ticket-login_close'}
      axios
        .post('/user/setting', data1)
        .then(res => {
          res = res.data
          if (res.res === '1') {
            this.codeOpen = true
          }
        })
    },
    getFairDetailSucc(res) {
      res = res.data
      if (res.status && res.data) {
        this.fairDetail = res.data.fair
        if (this.fairDetail.iskaishi !== 1) {
          if (this.fairDetail.iskaishi === '-1') {
            this.$dialog.toast({
              mes: '报名已结束'
            })
          } else {
            this.$dialog.toast({
              mes: '报名未开始'
            })
          }
          this.$router.push({path: '/' + this.params.id + '?code=' + this.$store.state.code})
          return false
        }
      }
    },
    HistoryBack() {
      this.$router.push({path: '/' + this.params.id + '?code=' + this.$store.state.code})
    },
    getTicket() {
      let data = {fairid: this.params.id, fenxiang: localStorage.getItem('code'), invoice: '1'}
      axios
        .post('/fair/baoming', data)
        .then(this.getTicketSucc)
    },
    getTicketSucc(res) {
      res = res.data
      if (res.status && res.data) {
        this.ticketList = res.data.huichang
        this.tuiguangren = res.data.tuiguangren
        // invoicetype separate is_open info invoice_content invoicemail InvoiceLeixing
        this.system = res.data.system
        if (this.system.is_open === '2') {
          this.iskai = 1
        }
        if (this.system.invoicemail === '2') {
          this.invoice.needmail = true
        }
      }
    },
    editInvoice() {
      alert('I\'m a invoice')
    },
    saveInvoice() {
      var type = ''
      if (this.invoice.type === '5') {
        type = '无需开票'
      }
      if (this.invoice.type === '1') {
        type = '普票'
      }
      if (this.invoice.type === '2') {
        type = '电子发票'
      }
      if (this.invoice.type === '3') {
        type = '增值发票'
      }
      if (this.iskai) {
        if (this.invoice.type === '5') {
          this.invoiceMsg = type
        } else {
          this.invoiceMsg = type + '(' + this.invoice.name + ')'
        }
      } else {
        this.invoiceMsg = '不开发票'
      }
      let invoiceRes = this.checkInvoice()
      if (invoiceRes) {
        this.invoiceShow = false
      }
    },
    buyTicket(hallid, ticket) {
      this.hallid = hallid
      this.goodsExt = ticket.goods_ext[0]
      this.contactsShow = true
    },
    delContact(goodsExt, index) {
      var ShoppingCart = localStorage.getItem('ShoppingCart' + this.params.id)
      var jsonstr = JSON.parse(ShoppingCart.substr(1, ShoppingCart.length))
      var productlist = jsonstr.productlist
      // var result = false
      for (var i in productlist) {
        if (productlist[i].id === goodsExt.id) {
          productlist[i].number = parseInt(productlist[i].number) - 1
          if (productlist[i].number === 0) {
            productlist.splice(i, 1)
            jsonstr.totalNumber = parseInt(jsonstr.totalNumber) - parseInt(1)
            jsonstr.totalAmount = parseFloat((parseFloat(jsonstr.totalAmount) - parseFloat(goodsExt.goods_price)).toFixed(2))
            localStorage.setItem('ShoppingCart' + this.params.id, '\'' + JSON.stringify(jsonstr))
            this.updateProduct()
            return false
          }
          for (var j = 0; j < productlist[i].contacts.length; j++) {
            if (j === index) {
              productlist[i].contacts.splice(j, 1)
              jsonstr.totalNumber = parseInt(jsonstr.totalNumber) - parseInt(1)
              jsonstr.totalAmount = parseFloat((parseFloat(jsonstr.totalAmount) - parseFloat(goodsExt.goods_price)).toFixed(2))
              localStorage.setItem('ShoppingCart' + this.params.id, '\'' + JSON.stringify(jsonstr))
              this.updateProduct()
              return false
            }
          }

          // result = true
        }
      }
      jsonstr.totalAmount = parseFloat((parseFloat(jsonstr.totalAmount) - parseFloat(goodsExt.goods_price)).toFixed(2))
      localStorage.setItem('ShoppingCart' + this.params.id, '\'' + JSON.stringify(jsonstr))
      this.updateProduct()
    },
    checkTicketCert(goodsExt, contacts) {
      var ShoppingCart = localStorage.getItem('ShoppingCart' + this.params.id)
      if (ShoppingCart === null || ShoppingCart === '') {
        return true
      } else {
        let jsonstr = JSON.parse(ShoppingCart.substr(1, ShoppingCart.length))
        var productList = jsonstr.productlist
        var result = false
        for (var i in productList) {
          if (productList[i].id === goodsExt.id) {
            productList[i].contacts.forEach(c => {
              if (c.user_name === contacts.user_name && c.company === contacts.company) {
                result = true
              }
            })
          }
        }
        if (result) {
          return false
        } else {
          return true
        }
      }
    },
    checkContactsRepeat() {
      let data = {
        contact: {
          'user_name': this.fieldsData.user_name,
          'company': this.fieldsData.company,
          'exh_goods_attr_id': this.goodsExt.goods_attr_id,
          'fair_id': this.params.id
        }
      }
      axios
        .post('/fair/check-admission', data)
        .then(res => {
          res = res.data
          if (res.status === 1) {
            this.saveContacts(true, true)
          } else {
            this.$dialog.toast({mes: res.msg})
          }
        })
    },
    checkContactRole() {
      let data = {
        goods_id: this.goodsExt.id,
        shuzu: [{
          'user_name': this.fieldsData.user_name,
          'mobile_phone': this.fieldsData.mobile_phone,
          'company': this.fieldsData.company,
          'bianhao': this.fieldsData.bianhao
        }]
      }
      axios
        .post('/user/check-contacts', data)
        .then(res => {
          res = res.data
          if (res.status === 1) {
            this.saveContacts(true)
          } else {
            this.$dialog.toast({mes: '不具备资格'})
          }
        })
    },
    saveContacts(contactsRole, contactsRepeat) {
      // 验证格式
      let res = this.checkContactFormat()
      if (res === false) {
        return false
      }

      // 验证购买资格  switch：checkticketrole_bs
      if (this.system.checkticketrole_bs === '1' && contactsRole !== true) {
        this.checkContactRole()
        return false
      }

      // 重复购买验证  switch：CheckContactsRepeat
      if ((this.system.CheckContactsRepeat === '1' || this.system.CheckContactsRepeat === '2') && contactsRepeat !== true) {
        let data = {
          'user_name': this.fieldsData.user_name,
          'company': this.fieldsData.company
        }
        if (this.checkTicketCert(this.goodsExt, data) === false) {
          this.$dialog.toast({mes: '该参会人已填写'})
          return false
        }
        this.checkContactsRepeat()
        return false
      }
      let ExhContactsExt = {}
      this.fields.forEach(field => {
        if (field.tablename !== 'exh_contacts') {
          if (field.field_type === 'checkbox') {
            ExhContactsExt[field.field_name] = this.fieldsData[field.field_name].toString()
          } else {
            ExhContactsExt[field.field_name] = this.fieldsData[field.field_name]
          }
        }
      })
      /** save data start */
      let data = {
        user_name: this.fieldsData.user_name,
        mobile_phone: this.fieldsData.mobile_phone,
        email: this.fieldsData.email,
        company: this.fieldsData.company,
        bianhao: this.fieldsData.bianhao,
        province: this.fieldsData.province,
        city: this.fieldsData.city,
        area: this.fieldsData.area,
        ExhContactsExt: ExhContactsExt
      }
      this.addTicketCert(this.goodsExt, data)
      this.contactsShow = false
      /** save data end */
    },
    addTicketCert(goodsExt, contacts) {
      var ShoppingCart = localStorage.getItem('ShoppingCart' + this.params.id)
      if (ShoppingCart === null || ShoppingCart === '') {
        let jsonstr = {
          'productlist': [{
            'id': goodsExt.id,
            'number': 1,
            'price': goodsExt.goods_price,
            'contacts': [contacts]
          }],
          'totalNumber': 1,
          'totalAmount': goodsExt.goods_price
        }
        localStorage.setItem('ShoppingCart' + this.params.id, '\'' + JSON.stringify(jsonstr))
        this.updateProduct()
      } else {
        let jsonstr = JSON.parse(ShoppingCart.substr(1, ShoppingCart.length))
        var productList = jsonstr.productlist
        var result = false
        for (var i in productList) {
          if (productList[i].id === goodsExt.id) {
            productList[i].number = parseInt(productList[i].number + 1)
            productList[i].contacts.push(contacts)
            result = true
          }
        }
        if (!result) {
          productList.push({
            'id': goodsExt.id,
            'number': 1,
            'price': goodsExt.goods_price,
            'contacts': [contacts]
          })
        }
        jsonstr.totalNumber = parseInt(jsonstr.totalNumber) + parseInt(1)
        jsonstr.totalAmount = parseFloat(jsonstr.totalAmount) + parseFloat(goodsExt.goods_price)
        localStorage.setItem('ShoppingCart' + this.params.id, '\'' + JSON.stringify(jsonstr))
        this.updateProduct()
      }
      return 0
    },
    clearTicketCert() {
      localStorage.removeItem('ShoppingCart' + this.params.id)
    },
    refreshData(key, value) { // 父子组件 同步、传值
      this[key] = value
    },
    checkSendCode() { // buy at least one ticket
      var ShoppingCart = localStorage.getItem('ShoppingCart' + this.params.id)
      if (ShoppingCart) {
        let jsonstr = JSON.parse(ShoppingCart.substr(1, ShoppingCart.length))
        if (parseInt(jsonstr.totalNumber) > 0) {
          if (this.order.contact) {
            return true
          } else {
            this.$dialog.toast({
              mes: '请先填写姓名'
            })
          }
        } else {
          this.$dialog.toast({
            mes: '请先填写参会者信息'
          })
        }
      }
      return false
    },
    sendCode() {
      let r = this.checkSendCode()
      if (!r) {
        return false
      }
      let res = this.checkFormat('phone')
      if (!res) {
        return false
      }
      this.$dialog.loading.open('发送中...')
      let data = {
        mobile: this.order.mobile_phone,
        type: 3,
        fair_id: this.params.id
      }
      axios
        .post('/user/send-sms', data)
        .then(this.sendSmsScc)
    },
    sendSmsScc(res) {
      res = res.data
      if (res.status) {
        this.codeStatus = true
        this.$dialog.loading.close()
        this.$dialog.toast({
          mes: '已发送'
        })
      } else {
        this.$dialog.loading.close()
        this.$dialog.toast({
          mes: '网络错误'
        })
      }
    },
    checkContactFormat() {
      let checkResult = true
      this.fields.forEach(field => {
        if (field.field_name === 'mobile_phone') {
          var phoneReg = /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
          if (field.required === '1' && this.fieldsData[field.field_name] === '') {
            this.$dialog.toast({
              mes: '请填写' + field.field_des
            })
            checkResult = false
          } else if (!phoneReg.test(this.fieldsData[field.field_name])) {
            this.$dialog.toast({
              mes: field.field_des + '格式不正确'
            })
            checkResult = false
          }
        } else if (field.field_name === 'email') {
          var emailReg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
          if (field.required === '1' && this.fieldsData[field.field_name] === '') {
            this.$dialog.toast({
              mes: '请填写' + field.field_des
            })
            checkResult = false
          } else if (!emailReg.test(this.fieldsData[field.field_name])) {
            this.$dialog.toast({
              mes: field.field_des + '格式不正确'
            })
            checkResult = false
          }
        } else if (field.required === '1' && this.fieldsData[field.field_name] === '') {
          this.$dialog.toast({
            mes: '请填写' + field.field_des
          })
          checkResult = false
        }
      })
      return checkResult
    },
    checkFormat(res) {
      if (res === 'phone') {
        if (this.order.mobile_phone === undefined || this.order.mobile_phone === null || this.order.mobile_phone.length !== 11) {
          this.$dialog.toast({
            mes: '请填写正确的手机号'
          })
          return false
        }
      } else if (res === 'code' && this.codeOpen === true) {
        if (this.order.mobile_phone === undefined || this.order.mobile_phone === null || this.order.mobile_phone.length !== 11) {
          this.$dialog.toast({
            mes: '请填写正确的手机号'
          })
          return false
        }
        if (this.code.length <= 0) {
          this.$dialog.toast({
            mes: '请填写验证码'
          })
          return false
        }
      } else if (res === 'code') {
        if (this.order.contact === undefined || this.order.contact === null || this.order.contact.length <= 0) {
          this.$dialog.toast({
            mes: '请填写联系人'
          })
          return false
        }
        if (this.order.mobile_phone === undefined || this.order.mobile_phone === null || this.order.mobile_phone.length !== 11) {
          this.$dialog.toast({
            mes: '请填写正确的手机号'
          })
          return false
        }
      }
      return true
    },
    async login() {
      let res = false
      let user = {}
      res = this.checkFormat('code')
      if (this.codeOpen === false) {
        user = {
          mobile_phone: this.order.mobile_phone,
          contact_name: this.order.contact,
          fairid: this.params.id,
          fenxiang: localStorage.getItem('code')
        }
      } else {
        user = {
          mobile_phone: this.order.mobile_phone,
          contact_name: this.order.contact,
          fairid: this.params.id,
          fenxiang: localStorage.getItem('code'),
          code: this.code
        }
      }
      if (!res) {
        return false
      }
      await axios
        .post('/user/login-unsensible', user)
        .then(this.loginSucc)
    },
    async loginSucc(res) {
      res = res.data
      if (res.status === 1) {
        localStorage.setItem('uid', res.data.uid)
        localStorage.setItem('token', res.data.token)
        localStorage.setItem('name', res.data.name)
        localStorage.setItem('mobile_phone', res.data.mobile_phone)
        this.token = res.data.token
      } else {
        this.$dialog.toast({
          mes: res.msg
        })
        return false
      }
      this.submitOrder()
    },
    updateProduct() {
      var ShoppingCart = localStorage.getItem('ShoppingCart' + this.params.id)
      if (ShoppingCart !== null && ShoppingCart !== '') {
        let jsonstr = JSON.parse(ShoppingCart.substr(1, ShoppingCart.length))
        this.productlist = jsonstr.productlist
        this.number = jsonstr.totalNumber
        this.amount = jsonstr.totalAmount
        this.getCoupon(this.productlist)
        this.updateCouponAmount()
      }
    },
    async submitOrder() {
      if (this.productlist.length === undefined || this.productlist.length <= 0) {
        this.$dialog.toast({
          mes: '至少购买一张'
        })
        return false
      }
      let invoiceRes = this.checkInvoice()
      if (!invoiceRes) {
        this.$dialog.toast({
          mes: '请检查发票信息是否正确'
        })
        return false
      }

      let a = ''
      if (!localStorage.getItem('token')) {
        let res = false
        let user = {}
        res = this.checkFormat('code')
        if (this.codeOpen === false) {
          user = {
            mobile_phone: this.order.mobile_phone,
            contact_name: this.order.contact,
            fairid: this.params.id,
            fenxiang: localStorage.getItem('code')
          }
        } else {
          user = {
            mobile_phone: this.order.mobile_phone,
            contact_name: this.order.contact,
            fairid: this.params.id,
            fenxiang: localStorage.getItem('code'),
            code: this.code
          }
        }
        if (!res) {
          return false
        }
        await axios
          .post('/user/login-unsensible', user)
          .then(this.loginSucc)
        return false
      }
      console.log(a)
      let data = {
        'ExhBusinessOrder': {
          'message': this.order.message,
          'product_type': 22,
          'order_name': '买票',
          'order_fair_id': this.params.id,
          'businessman_id': localStorage.getItem('uid'),
          'youhui_total': this.couponAmount,
          'shoukuanf': this.order.shoukuanf
        },
        'ExhInvoice': {
          'type': this.invoice.type,
          'content': this.invoice.content,
          'way': this.invoice.way,
          'leixing': this.invoice.leixing,
          'lxr': this.invoice.lxr,
          'mobile': this.invoice.mobile,
          'province': this.invoice.province,
          'city': this.invoice.city,
          'dist': this.invoice.dist,
          'address': this.invoice.address,
          'name': this.invoice.name,
          'shuino': this.invoice.shuino,
          'zzaccount': this.invoice.zzaccount,
          'zzbank': this.invoice.zzbank,
          'zzphone': this.invoice.zzphone,
          'zzaddress': this.invoice.zzaddress,
          'email': this.invoice.email,
          'needmail': this.invoice.needmail
        },
        'goods': this.productlist,
        'fenxiang': localStorage.getItem('code'),
        'iskai': this.iskai,
        'exh_coupon_type_id': this.coupon
      }
      let that = this
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.token
      axios
        .post('/fair/tijiao', data)
        .then(this.submitOrderSucc)
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    submitOrderSucc(res) {
      res = res.data
      if (res.status === 1) {
        this.clearTicketCert()
        this.$dialog.toast({
          mes: '提交成功'
        })
        this.$router.push({path: 'fair-pay/' + res.data.orderid})
      } else {
        this.$dialog.toast({
          mes: res.msg
        })
      }
    },
    checkInvoiceRequire() {
      this.invoiceEmailRequire = false
      this.wuxu = false
      if (this.invoice.type === '5') {
        this.wuxu = true
        this.invoiceNameRequire = false
        this.invoiceShuinoRequire = false
        this.invoiceZzaddressRequire = false
        this.invoiceZzphoneRequire = false
        this.invoiceZzbankRequire = false
        this.invoiceZzaccountRequire = false
        this.invoiceLxrRequire = false
        this.invoicePcdRequire = false
        this.invoiceMobileRequire = false
        this.invoiceAddressRequire = false
      } else if (this.invoice.type === '1') {
        this.invoiceNameRequire = true
        this.invoiceZzaddressRequire = false
        this.invoiceZzphoneRequire = false
        this.invoiceZzbankRequire = false
        this.invoiceZzaccountRequire = false
      } else if (this.invoice.type === '2') {
        this.invoiceNameRequire = true
        this.invoiceZzaddressRequire = false
        this.invoiceZzphoneRequire = false
        this.invoiceZzbankRequire = false
        this.invoiceZzaccountRequire = false
        this.invoiceEmailRequire = true
        this.invoiceLxrRequire = true
        this.invoiceMobileRequire = true
      } else if (this.invoice.type === '3') {
        this.invoiceNameRequire = true
        this.invoiceShuinoRequire = true
        this.invoiceZzaddressRequire = true
        this.invoiceZzphoneRequire = true
        this.invoiceZzbankRequire = true
        this.invoiceZzaccountRequire = true
      }
      if (this.invoice.type === '5' || (this.invoice.leixing === '1' && this.invoice.type !== '3')) {
        this.invoiceShuinoRequire = false
      } else {
        this.invoiceShuinoRequire = true
      }
      if (this.invoice.needmail === true) {
        this.invoiceLxrRequire = true
        this.invoicePcdRequire = true
        this.invoiceMobileRequire = true
        this.invoiceAddressRequire = true
      } else {
        if (this.invoice.type !== '2') {
          this.invoiceLxrRequire = false
          this.invoiceMobileRequire = false
        }
        this.invoicePcdRequire = false
        this.invoiceAddressRequire = false
      }
    },
    checkInvoice() {
      if (this.iskai) {
        if (this.invoice.type === '5') {
          return true
        }
        if (this.invoice.type === '' || this.invoice.type.length <= 0) {
          this.$dialog.toast({
            mes: '发票类型必填'
          })
          return false
        }
        if (this.order.shoukuanf === '' || this.order.shoukuanf.length <= 0) {
          this.$dialog.toast({
            mes: '收款方必填'
          })
          return false
        }
        if (this.invoice.leixing === '' || this.invoice.leixing.length <= 0) {
          this.$dialog.toast({
            mes: '发票抬头类别必填'
          })
          return false
        }
        if (this.invoiceNameRequire) {
          if (this.invoice.name === '' || this.invoice.name.trim().length <= 0) {
            this.$dialog.toast({
              mes: '发票名称必填'
            })
            return false
          }
        }
        if (this.invoiceShuinoRequire) {
          if (this.invoice.shuino === '' || this.invoice.shuino.trim().length <= 0) {
            this.$dialog.toast({
              mes: '发票税号必填'
            })
            return false
          }
        }
        if (this.invoiceZzaddressRequire) {
          if (this.invoice.zzaddress === '' || this.invoice.zzaddress.trim().length <= 0) {
            this.$dialog.toast({
              mes: '单位地址必填'
            })
            return false
          }
        }
        if (this.invoiceZzphoneRequire) {
          if (this.invoice.zzphone === '' || this.invoice.zzphone.trim().length <= 0) {
            this.$dialog.toast({
              mes: '电话号码必填'
            })
            return false
          }
        }
        if (this.invoiceZzbankRequire) {
          if (this.invoice.zzbank === '' || this.invoice.zzbank.trim().length <= 0) {
            this.$dialog.toast({
              mes: '开户银行必填'
            })
            return false
          }
        }
        if (this.invoiceZzaccountRequire) {
          if (this.invoice.zzaccount === '' || this.invoice.zzaccount.trim().length <= 0) {
            this.$dialog.toast({
              mes: '银行账户必填'
            })
            return false
          }
        }
        if (this.invoiceLxrRequire) {
          if (this.invoice.lxr === '' || this.invoice.lxr.trim().length <= 0) {
            this.$dialog.toast({
              mes: '收件人姓名必填'
            })
            return false
          }
        }
        if (this.invoiceMobileRequire) {
          if (this.invoice.mobile === '' || this.invoice.mobile.trim().length <= 0) {
            this.$dialog.toast({
              mes: '收件人手机号必填'
            })
            return false
          }
        }
        if (this.invoiceEmailRequire) {
          if (this.invoice.email === '' || this.invoice.email.trim().length <= 0) {
            this.$dialog.toast({
              mes: '收件人邮箱必填'
            })
            return false
          }
        }
        if (this.invoicePcdRequire) {
          if (this.invoice.province === '' || this.invoice.province.trim().length <= 0 || this.invoice.city === '' || this.invoice.city.trim().length <= 0 || this.invoice.dist === '' || this.invoice.dist.trim().length <= 0) {
            this.$dialog.toast({
              mes: '收件人省市县必填'
            })
            return false
          }
        }
        if (this.invoiceAddressRequire) {
          if (this.invoice.address === '' || this.invoice.address.trim().length <= 0) {
            this.$dialog.toast({
              mes: '收件人详细地址必填'
            })
            return false
          }
        }
      }
      return true
    },
    checkShoukuanfang () {
      let that = this
      that.invoice_type[1] = 0
      that.invoice_type[2] = 0
      that.invoice_type[3] = 0
      this.system.shoukuanfang[this.order.shoukuanf].forEach(item => {
        that.invoice_type[item] = 1
      })
    },
    result1(ret) {
      this.pcd = ret.itemName1 + ' ' + ret.itemName2 + ' ' + ret.itemName3
      this.invoice.province = ret.itemValue1
      this.invoice.city = ret.itemValue2
      this.invoice.dist = ret.itemValue3
    },
    getCoupon(array) {
      let data = []
      array.forEach(item => {
        let tmp = {}
        tmp['pid'] = item.id
        tmp['cons'] = []
        if (item.contacts.length > 0) {
          item.contacts.forEach(contact => {
            tmp['cons'].push({
              'id': contact.id,
              'name': contact.user_name,
              'phone': contact.mobile_phone,
              'company': contact.company
            })
          })
        }
        data.push(tmp)
      })
      let that = this
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.token
      axios
        .post('/fair/get-coupon', {'data': JSON.stringify(data), 'fairid': this.params.id})
        .then(res => {
          res = res.data
          if (res.isCoupon === 1) {
            this.couponList = res.ExhCouponType
          } else {
            this.couponList = []
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    updateCouponAmount() {
      let result = false
      if (this.couponList.length > 0) {
        this.couponList.forEach(c => {
          if (c.id === this.coupon) {
            this.couponAmount = c.coupon_price
            result = true
          }
        })
      }
      if (result === false) {
        this.couponAmount = 0
      }
    },
    getFieldName() {
      axios
        .post('/fair/getfield', {fairid: this.params.id})
        .then(res => {
          res = res.data
          if (res.status === 1) {
            let fields = res.data
            this.fields = res.data
            fields.forEach(field => {
              if (field.field_type === 'checkbox') {
                this.fieldsData[field.field_name] = []
              } else {
                this.fieldsData[field.field_name] = ''
              }
            })
          }
        })
    }
  },
  mounted() {
    if (localStorage.ing === '0' || localStorage.ing === '-1') {
      if (localStorage.ing !== '-1') {
        this.$dialog.toast({
          mes: '报名未开始'
        })
      } else {
        this.$dialog.toast({
          mes: '报名已结束'
        })
      }

      this.$router.push({path: '/' + this.params.id + '?code=' + this.$store.state.code})
      return false
    }
    this.getFieldName()
    this.getFairDetail()
    this.getTicket()
    this.updateProduct()
    if (localStorage.ticket_xuzhi) {
      this.$dialog.alert({mes: localStorage.ticket_xuzhi})
    }
  },
  watch: {
    'invoice.type': function () {
      this.checkInvoiceRequire()
    },
    'invoice.leixing': function () {
      this.checkInvoiceRequire()
    },
    'invoice.needmail': function () {
      this.checkInvoiceRequire()
    },
    'order.shoukuanf': function () {
      this.checkShoukuanfang()
    },
    'coupon': function () {
      this.updateCouponAmount()
    },
    'iskai': function () {
      this.invoice.leixing = 1
      if (this.system.InvoiceLeixing === '2') {
        this.invoice.leixing = 2
      }
      for (let key in this.system.invoicetype) {
        this.invoice.type = key
        break
      }
      for (let key in this.system.invoice_content) {
        this.invoice.content = key
        break
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.clearfix
  clear: both

.fair-name
  color: #333
  font-size: .32rem

.fair
  text-align left !important

.invoice h3
  color: black
  font-size: .32rem
  margin .3rem 0

.ticket-price
  color: #FE6701
  line-height: .32rem !important

.ticket-name
  max-width: 70%
  white-space: nowrap
  text-overflow: ellipsis
  overflow: hidden
  color: #333
  line-height: .32rem
  text-align-last left

.ticket-name img
  float left
  width .36rem
  margin .02rem 0.12rem .06rem 0

.yd-scrollview::after
  display: none

.yd-preview
.waibu_cell_box
  width: calc(100% - 0.4rem)
  margin: 0 auto
  margin-bottom: .2rem
  border-radius: .12rem

.m-cell-box
  margin-bottom: 2.1rem

.yd-preview-item
  padding: 0 .4rem
  padding-bottom: .28rem
  line-height: .32rem

.yd-preview-item > :last-child
  line-height: 0.48rem

.meeting_inf .yd-preview-item
  padding-bottom: .16rem !important

.yd-preview-header
  height: auto
  margin: 0 auto
  padding: .32rem .4rem
  background: linear-gradient(to right, rgba(0, 200, 0, 1), rgba(0, 200, 0, 0.8))

.meeting_notify
  line-height: .32rem !important

.meeting_inf
  margin-top: .2rem
  padding-bottom: .2rem

.yd-btn
  border-radius: .06rem

.yd-icon-delete
  font-size: .32rem !important

.yd-icon-more
  font-size: .32rem !important
  margin-left: .08rem

.waibu_cell_box .yd-cell-item
  padding: 0 .4rem

.waibu_cell_box .yd-cell::after
  display: none

.waibu_cell_box .yd-cell-item::after
  width: calc(100% - .8rem) !important
  margin-left: .4rem !important

.total_price
  background-color: #fff
  color: #333
  width: 50%
  height: 1.32rem
  font-size: .32rem
  line-height: 0.54rem
  margin: 0
  padding: .12rem 0 .12rem .6rem
  border-radius: 0 !important
  float: left

.btn_submit
  margin: 0 !important
  width: 100%
  border-radius: 0 !important

// .submit
//   float: right
/*  width: 50%*/

.submit_total_price
  width: 100%
  max-width: 15rem
  z-index: 1500
  position: fixed
  bottom: 0

//background-color #fff
//.submit_total_price .waibu_cell_box
//float left
//width calc(100% - 2.08rem)
//display flex
//justify-content flex-end
//height 1rem
//.submit_total_price .waibu_cell_box>:first-child
//background-color transparent
//.submit_total_price .waibu_cell_box>:first-child>:first-child
//display block

.submit_total_price .yd-flexbox-item
  width: auto
  height: 1rem

.submit_total_price .yd-flexbox-item:nth-child(1)
  padding-left: .4rem

.submit_total_price .yd-flexbox-item:nth-child(2)
  text-align: center

.submit_total_price .yd-flexbox-item:nth-child(3)
  padding-right: .4rem
  text-align: right

.add_popup .yd-cell-item
  padding: 0

.add_popup > :last-child > :first-child
  padding: 0

.add_popup > :last-child > :first-child > :first-child
  padding: .2rem .4rem .2rem .2rem
  position: relative

.add_popup .yd-cell-item::after
  width: 100% !important
  margin: 0 !important

.member_info
  line-height: .52rem
  width: 85%
  float: left

.member_name
  float: left
  width: 35%
  text-align-last: left
  overflow hidden

.member_name img
  width .36rem
  height .36rem
  float left
  margin .06rem .06rem .08rem 0

.operation
  float: left
  width: 4%


.canhuiren
  padding: .2rem .4rem
  padding-top 0

.canhuiren .yd-preview-item
  padding-bottom: 0

.chr_title p
  color: #FFFFFF
  width: calc(100% / 3)
  text-align: center
  display: inline-block
  line-height: .52rem
  float: left

.canhuiren > :last-child
  margin-bottom: .28rem

.canhuiren > :first-child
  margin-bottom 0


.canhuiren_v_for
  // border-top: solid 1px #f2f2f2
.yd-cell label.yd-cell-item:active
  background: none !important

.order_amount
  color: red

.bk_none > :first-child > :first-child
  background: transparent

.close_btn
  color: #fff
  width: 0
  height: 0
  border: solid .45rem
  border-color: orangered orangered transparent transparent
  border-top-right-radius: .2rem
  position: fixed
  z-index 99
  top: 0
  right: 0

.close_btn span
  font-size: .24rem
  position: absolute
  top: -0.3rem
  right: -0.3rem

.invoice_h1
  font-size .4rem

.yd-radio
  display block
  float left
  margin-bottom .26rem

.radio_box
  overflow hidden

.meeting_inf_header
  color #333

.meeting_inf_header::after
  display none

.add.active
.add
  background-color transparent !important
  color #666
  border solid #dcdcdc 0.02rem
  border-radius .24rem
  font-size .24rem
  line-height .48rem
  height auto

.no-af
  line-height .32rem !important

.no-af > :last-child::after
  display none

.no-af a
  height 100%


.lxr.yd-cell-item
  min-height unset
  height unset

.lxr.yd-cell-item::after
  display none

.lxr.yd-cell-item > :first-child
  display block

.lxr.yd-cell-item > :last-child
.sjh.yd-cell-item > :last-child
  min-height unset

.lxr.yd-cell-item > :last-child > :first-child > :first-child
  height auto
  line-height .28rem
  padding-bottom .28rem

.sjh.yd-cell-item
  padding-bottom .28rem

.sjh.yd-cell-item > :last-child > :first-child > :first-child
  height auto


</style>



// WEBPACK FOOTER //
// src/views/template1/FairBuy.vue